import { Reveal, SectionLabel } from "./Reveal";
import { MapPin, ArrowRight } from "lucide-react";

export default function Events({ site, events }) {
  const s = site?.eventsSection || {};
  const go = (href) => {
    if (href?.startsWith("#")) document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section id="events" className="py-24 lg:py-32 bg-[var(--c-bg-alt)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <SectionLabel>{s.label}</SectionLabel>
          <h2 className="font-heading font-bold text-[var(--c-primary)] mt-5 text-3xl sm:text-4xl lg:text-5xl">{s.title}</h2>
          <p className="font-body text-[var(--c-muted)] mt-5 text-base sm:text-lg">{s.subtitle}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {(events || []).map((e, i) => (
            <Reveal key={e.id || i} delay={(i % 4) * 0.07}>
              <div data-testid={`event-card-${i}`} className="group h-full flex flex-col bg-[var(--c-card)] rounded-2xl border border-[var(--c-border)] overflow-hidden hover:-translate-y-1 transition-transform duration-300">
                <div className="relative h-44 overflow-hidden">
                  <img src={e.image} alt={e.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 duration-700 ease-out" />
                  <span className="absolute top-3 left-3 rounded-full bg-[var(--c-primary)] text-white text-xs font-body px-3 py-1.5">{e.date}</span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-heading text-lg font-semibold text-[var(--c-primary)]">{e.title}</h3>
                  <p className="font-body text-sm text-[var(--c-muted)] mt-2 leading-relaxed flex-1">{e.desc}</p>
                  {e.venue && (
                    <div className="flex items-center gap-1.5 mt-4 text-[var(--c-secondary)] font-body text-sm">
                      <MapPin className="h-4 w-4" /> {e.venue}
                    </div>
                  )}
                  {e.regLink && (
                    <button onClick={() => go(e.regLink)} className="inline-flex items-center gap-1 font-body text-sm text-[var(--c-primary)] mt-4 hover:gap-2 transition-all">
                      রেজিস্টার করুন <ArrowRight className="h-4 w-4" />
                    </button>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
